module.exports = __webpack_public_path__ + "img/问卷投票.83d5c0f7.png";